var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueunload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_2121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.657471 22.0062C0.657471 22.556 1.10136 23.0027 1.65118 23.0062L17.7373 23.1074C18.292 23.1109 18.7436 22.6622 18.7436 22.1074V19.961C18.7436 19.4087 18.2959 18.961 17.7436 18.961H1.65747C1.10519 18.961 0.657471 19.4087 0.657471 19.961V22.0062ZM16.9607 7.27222C17.6082 7.89678 17.1661 8.99195 16.2665 8.99195H14.5761C14.0238 8.99195 13.5761 9.43967 13.5761 9.99195V15.4687C13.5761 16.021 13.1284 16.4687 12.5761 16.4687H6.82494C6.27265 16.4687 5.82493 16.021 5.82493 15.4687V9.99195C5.82493 9.43967 5.37722 8.99195 4.82493 8.99195H3.13457C2.23495 8.99195 1.79284 7.89678 2.44032 7.27222L9.00628 0.938715C9.39369 0.565025 10.0074 0.565026 10.3948 0.938716L16.9607 7.27222Z",
    fill: "#329DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_2121",
    x: 0.657471,
    y: 0.658691,
    width: 18.0862,
    height: 23.4487,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueunload);
export default __webpack_public_path__ + "static/media/blueunload.1a732adfa088fa297d4ccd2d35c7273b.svg";
export { ForwardRef as ReactComponent };